import { useState } from 'react';
import { getSessionIdFromCookie } from 'utils/identifierCookies';

const useSession = () => {
  // Read synchronously from the redirect-owned cookie so API calls and event
  // logging share the same session identifier without storage fallbacks.
  const [sessionId] = useState<string>(() => getSessionIdFromCookie());

  return sessionId;
};

export default useSession;
